<svg
        [attr.height]="height"
        [attr.width]="width"
        fill="none"
        style="overflow: visible"
        viewBox="0 0 54 54"
        xmlns="http://www.w3.org/2000/svg">
    <circle cx="27" cy="27" fill="#424242" r="26"/>
    <circle [attr.fill]="backgroundColor" cx="27" cy="27" r="23"/>
    <g>
        <path d="M16.9569 14.9438C14.8293 17.0119 13.7338 19.8077 13.7338 22.7853C13.7338 25.7055 14.8293 28.4985 16.9569 30.6269L15.1326 32.5128C12.3963 29.7761 11.0612 26.1894 11 22.6027C11.0587 19.2598 12.2153 15.7946 15.0714 13L16.9569 14.9438Z"
              fill="#424242"/>
        <path d="M22.0256 18.3478C20.7491 19.5651 20.0793 21.3283 20.0793 22.9076C20.0793 24.4877 20.688 26.067 21.8421 27.224L20.1401 28.9256C18.4996 27.2852 17.4653 24.9745 17.4653 22.7241C17.4653 20.5994 18.3161 18.4089 20.2628 16.5234L22.0256 18.3478Z"
              fill="#424242"/>
        <path d="M24.2261 21.2867C24.2261 19.7685 25.5021 18.4917 27.0211 18.4917C28.6033 18.4917 29.8185 19.7681 29.8185 21.2867C29.8185 22.8073 28.6033 24.0841 27.0211 24.0841C25.5021 24.0846 24.2261 22.8073 24.2261 21.2867Z"
              fill="#424242"/>
        <path d="M31.8667 27.3461C33.1427 26.1288 33.8105 24.3656 33.8105 22.7243C33.8105 21.2673 33.2018 19.6265 32.0469 18.4091L33.7493 16.7075C35.3286 18.4703 36.4245 20.6583 36.4245 22.9698C36.4245 25.0945 35.5741 27.2858 33.6882 29.1097L31.8667 27.3461Z"
              fill="#424242"/>
        <path d="M37.3926 30.7505C39.5202 28.6815 40.6132 25.8865 40.5524 22.9081C40.6128 19.9892 39.5198 17.1347 37.3926 15.0058L39.2145 13.2422C41.9503 15.9173 43.2883 19.5044 43.3491 23.0916C43.2883 26.4345 42.1338 29.8989 39.2752 32.6331L37.3926 30.7505Z"
              fill="#424242"/>
        <path d="M28.1664 26.6006H25.6907C25.1719 26.6006 24.9392 27.066 24.9392 27.6398L21.481 40.9999L27.0221 37.2597L32.5632 40.9999L29.105 27.6398C29.1054 27.0656 28.6851 26.6006 28.1664 26.6006Z"
              fill="#424242"/>
    </g>
</svg>
